import {
  SEARCH_VEHICLES_BY_LICENSE_PLATE,
  SEARCH_VEHICLES_BY_LICENSE_PLATE_SUCCESS,
  SEARCH_VEHICLES_BY_LICENSE_PLATE_ERROR,
  GET_VEHICLE,
  GET_VEHICLE_SUCCESS,
  GET_VEHICLE_ERROR,
  GET_VEHICLES_BY_STUDENT,
  GET_VEHICLES_BY_STUDENT_SUCCESS,
  GET_VEHICLES_BY_STUDENT_ERROR,
  CREATE_VEHICLE,
  CREATE_VEHICLE_SUCCESS,
  CREATE_VEHICLE_ERROR,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_ERROR,
  LINK_PERSON_TO_VEHICLE,
  LINK_PERSON_TO_VEHICLE_SUCCESS,
  LINK_PERSON_TO_VEHICLE_ERROR,
  UPDATE_PERSON_LINK,
  UPDATE_PERSON_LINK_SUCCESS,
  UPDATE_PERSON_LINK_ERROR,
  UNLINK_PERSON,
  UNLINK_PERSON_SUCCESS,
  UNLINK_PERSON_ERROR,
  SET_DUPLICATE_PLATE_WARNING,
  CLEAR_DUPLICATE_PLATE_WARNING,
} from './types';

const initialState = {
  searchResults: [],
  studentVehicles: [],
  selectedVehicle: null,
  loading: {
    search: false,
    get: false,
    getByStudent: false,
    create: false,
    update: false,
    linkPerson: false,
    updatePersonLink: false,
    unlinkPerson: false,
  },
  error: {
    search: null,
    get: null,
    getByStudent: null,
    create: null,
    update: null,
    linkPerson: null,
    updatePersonLink: null,
    unlinkPerson: null,
  },
  searchPerformed: false,
  duplicatePlateWarning: false,
};

const vehiclesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Search
    case SEARCH_VEHICLES_BY_LICENSE_PLATE:
      return {
        ...state,
        loading: { ...state.loading, search: true },
        error: { ...state.error, search: null },
      };
    case SEARCH_VEHICLES_BY_LICENSE_PLATE_SUCCESS:
      return {
        ...state,
        searchResults: payload,
        loading: { ...state.loading, search: false },
        searchPerformed: true,
      };
    case SEARCH_VEHICLES_BY_LICENSE_PLATE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, search: false },
        error: { ...state.error, search: 'Failed to search vehicles' },
      };

    // Get vehicles by student
    case GET_VEHICLES_BY_STUDENT:
      return {
        ...state,
        loading: { ...state.loading, getByStudent: true },
        error: { ...state.error, getByStudent: null },
      };
    case GET_VEHICLES_BY_STUDENT_SUCCESS:
      return {
        ...state,
        studentVehicles: payload,
        loading: { ...state.loading, getByStudent: false },
      };
    case GET_VEHICLES_BY_STUDENT_ERROR:
      return {
        ...state,
        studentVehicles: [],
        loading: { ...state.loading, getByStudent: false },
        error: { ...state.error, getByStudent: 'Failed to load vehicles for student' },
      };

    // Get vehicle
    case GET_VEHICLE:
      return {
        ...state,
        loading: { ...state.loading, get: true },
        error: { ...state.error, get: null },
      };
    case GET_VEHICLE_SUCCESS:
      return {
        ...state,
        selectedVehicle: payload,
        loading: { ...state.loading, get: false },
      };
    case GET_VEHICLE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, get: false },
        error: { ...state.error, get: 'Failed to get vehicle' },
      };

    // Create vehicle
    case CREATE_VEHICLE:
      return {
        ...state,
        loading: { ...state.loading, create: true },
        error: { ...state.error, create: null },
      };
    case CREATE_VEHICLE_SUCCESS:
      return {
        ...state,
        selectedVehicle: payload,
        loading: { ...state.loading, create: false },
      };
    case CREATE_VEHICLE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, create: false },
        error: { ...state.error, create: 'Failed to create vehicle' },
      };

    // Update vehicle
    case UPDATE_VEHICLE:
      return {
        ...state,
        loading: { ...state.loading, update: true },
        error: { ...state.error, update: null },
      };
    case UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        selectedVehicle: payload,
        loading: { ...state.loading, update: false },
      };
    case UPDATE_VEHICLE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, update: false },
        error: { ...state.error, update: 'Failed to update vehicle' },
      };

    // Link person
    case LINK_PERSON_TO_VEHICLE:
      return {
        ...state,
        loading: { ...state.loading, linkPerson: true },
        error: { ...state.error, linkPerson: null },
      };
    case LINK_PERSON_TO_VEHICLE_SUCCESS:
      return {
        ...state,
        selectedVehicle: {
          ...state.selectedVehicle,
          linkedPersons: payload.linkedPersons || state.selectedVehicle?.linkedPersons || [],
        },
        loading: { ...state.loading, linkPerson: false },
      };
    case LINK_PERSON_TO_VEHICLE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, linkPerson: false },
        error: { ...state.error, linkPerson: 'Failed to link person' },
      };

    // Update person link
    case UPDATE_PERSON_LINK:
      return {
        ...state,
        loading: { ...state.loading, updatePersonLink: true },
        error: { ...state.error, updatePersonLink: null },
      };
    case UPDATE_PERSON_LINK_SUCCESS:
      return {
        ...state,
        selectedVehicle: {
          ...state.selectedVehicle,
          linkedPersons: payload.linkedPersons || state.selectedVehicle?.linkedPersons || [],
        },
        loading: { ...state.loading, updatePersonLink: false },
      };
    case UPDATE_PERSON_LINK_ERROR:
      return {
        ...state,
        loading: { ...state.loading, updatePersonLink: false },
        error: { ...state.error, updatePersonLink: 'Failed to update owner status' },
      };

    // Unlink person
    case UNLINK_PERSON:
      return {
        ...state,
        loading: { ...state.loading, unlinkPerson: true },
        error: { ...state.error, unlinkPerson: null },
      };
    case UNLINK_PERSON_SUCCESS:
      return {
        ...state,
        selectedVehicle: {
          ...state.selectedVehicle,
          linkedPersons: state.selectedVehicle?.linkedPersons?.filter(
            (p) => p.vehiclePersonId !== payload.vehiclePersonId
          ) || [],
        },
        loading: { ...state.loading, unlinkPerson: false },
      };
    case UNLINK_PERSON_ERROR:
      return {
        ...state,
        loading: { ...state.loading, unlinkPerson: false },
        error: { ...state.error, unlinkPerson: 'Failed to unlink person' },
      };

    // Duplicate plate warning
    case SET_DUPLICATE_PLATE_WARNING:
      return {
        ...state,
        duplicatePlateWarning: true,
      };
    case CLEAR_DUPLICATE_PLATE_WARNING:
      return {
        ...state,
        duplicatePlateWarning: false,
      };

    default:
      return state;
  }
};

export default vehiclesReducer;
